export default {
    contactUs: 'Kontaktirajte nas',
    contact: 'Kontakt',
    blogTitle: 'Gradimo budućnost u njezi osmijeha',
    blogDescription: 'Razvijamo proizvode na uvjerenju da izbjeljivanje zubi može biti učinkovito i sigurno.',
    blogButton: 'Prikaži sve',
    allAboutHelloCoco: 'Sve o hello coco',
    aboutUs: 'O nama',
    reviews: 'Recenzije',
    reviewsLink: '/recenze/',
    cocoEmail: 'kontakt@hellococo.hr',
    termsAndConditions: 'Uvjeti poslovanja',
    termsAndConditionsLink: '/uvjeti-poslovanja/',
    privacyPolicy: 'Zaštita privatnosti',
    privacyPolicyLink: '/zastita-privatnosti/',
    purchase: 'Kupnja',

    emptyCartText: 'Košarica čeka na svoja prva otkrića - pogledajte našu ponudu!',
    startShopping: 'Započnite kupovinu',

    orderSummary: 'Sažetak narudžbe',
    shippingAndPayment: 'Dostava i plaćanje',
    discountCoupon: 'Kupon za popust',
    applyDiscount: 'Primijeni',
    giftsHeading: 'Odaberite BESPLATAN poklon',

    orderInfo: 'Vaši podaci',
    orderNumber: 'Broj narudžbe',

    'header.others': 'Ostalo',
    'header.categories': 'Kategorije',
    'header.followUs': 'Pratite nas',

    'emptyCart.title': 'Vaša košarica je prazna',
    'emptyCart.backToShop': 'Natrag u trgovinu',

    show_all: 'Prikaži sve',

    'login.title': 'Prijava na svoj račun',
    'login.button': 'Prijava',
    'login.forgotPassword': 'Zaboravljena lozinka',
    'login.createAccount': 'Registracija',

    'global.freeDelivery': 'Imate besplatnu dostavu!',

    'filter.recommended': 'Preporučujemo',
    'filter.leastExpensive': 'Najjeftinije',
    'filter.mostExpensive': 'Najskuplji',
    'filter.alphabetically': 'Abecedno',

    aboutUsLink: '/o-nama/',
    contactUsLink: '/kontakt/',

    'email.placeholder': 'Unesite svoju e-poštu',

    'instagram.title': 'Stručnjaci za njegu osmijeha @hellococo_hr',
    'instagram.url': 'https://www.instagram.com/hellococo_hr/',
    'facebook.url': 'https://www.facebook.com/profile.php?id=61565577736777',
}
